import { CheckCircleIcon, ClockIcon, CreditCardIcon, WarningCircleIcon } from '@phosphor-icons/react';
import type { RecurringPaymentStatusView } from '@/lib/recurring/paymentStatus';
import { cn } from '@/lib/utils';

const CHIP: Record<
  RecurringPaymentStatusView,
  { label: string; className: string; Icon: typeof CheckCircleIcon }
> = {
  paga: { label: 'Paga', className: 'bg-success-surface text-success-text', Icon: CheckCircleIcon },
  'na-fatura': { label: 'Na fatura', className: 'bg-info-surface text-info-text', Icon: CreditCardIcon },
  prevista: { label: 'Prevista', className: 'bg-warning-surface text-warning-text', Icon: ClockIcon },
  atrasada: { label: 'Atrasada', className: 'bg-error-surface text-error-text', Icon: WarningCircleIcon },
};

interface Props {
  status: RecurringPaymentStatusView;
  /** `sm` is the list-row density; `md` the one the home widget and the drawer hero use. */
  size?: 'sm' | 'md';
  className?: string;
}

export function RecurringStatusChip({ status, size = 'md', className }: Props) {
  const chip = CHIP[status];
  const { Icon } = chip;
  return (
    <span
      data-status={status}
      className={cn(
        'inline-flex shrink-0 items-center gap-1 rounded-full font-medium',
        size === 'sm' ? 'px-2 py-0.5 text-3xs' : 'px-2.5 py-1 text-xs',
        chip.className,
        className,
      )}
    >
      <Icon size={size === 'sm' ? 11 : 13} weight="fill" aria-hidden />
      {chip.label}
    </span>
  );
}
